import React from 'react'

function Breadcrumbs({ title, breadcrumbs }) {
  // Get current path
  const getCurrentPath = () => {
    return window.location.pathname;
  };

  // Check if a breadcrumb item is the current page
  const isCurrentPage = (item) => {
    const currentPath = getCurrentPath();

    // If item has explicit active flag, use it
    if (item.active !== undefined) {
      return item.active;
    }

    // If item has href, check if it matches current path
    if (item.href) {
      // Special handling for homepage
      if (item.href === '/' && currentPath === '/') {
        return false; // Home is never active in breadcrumbs when on homepage
      }
      // Check if current path matches this breadcrumb
      return currentPath === item.href || currentPath.startsWith(item.href + '/');
    }

    // If no href, this is the last item (current page)
    return true;
  };

  // If breadcrumbs array is provided, use it; otherwise default to Home > title
  const breadcrumbItems = breadcrumbs || [
    { label: 'Home', href: '/' },
    { label: title, active: true }
  ]

  return (
    <div className="breadcrumb__area breadcrumb-space overflow-hidden banner-home-bg ">
      <div className="banner-home__middel-shape inner-top-shape"></div>
      <div className="container">
        <div className="banner-all-shape-wrapper">
          <div className="banner-home__banner-shape-1 first-shape">
            <img className="upDown-top" src="assets/imgs/banner-1/banner-shape-1.svg" alt="Decorative Banner Shape 1" />
          </div>
          <div className="banner-home__banner-shape-2 second-shape">
            <img className="upDown-bottom" src="assets/imgs/banner-1/banner-shape-2.svg" alt="Decorative Banner Shape 2" />
          </div>
          {/* <div className="right-shape">
            <img className="zooming" src="assets/imgs/inner-img/inner-right-shape.svg" alt="img not found" />
          </div> */}
        </div>
        <div className="row align-items-center justify-content-between">
          <div className="col-12">
            <div className="breadcrumb__content text-center">
              <div className="breadcrumb__title-wrapper mb-15 mb-sm-10 mb-xs-5">
                <h1 className="breadcrumb__title color-white wow fadeIn animated" data-wow-delay=".1s">{title}</h1>
              </div>
              <div className="breadcrumb__menu wow fadeIn animated" data-wow-delay=".5s">
                <nav>
                  <ul>
                    {breadcrumbItems.map((item, index) => (
                      <li
                        key={index}
                        className={isCurrentPage(item) ? 'active' : ''}
                        style={isCurrentPage(item) ? { opacity: 1 } : {}}
                      >
                        <span style={isCurrentPage(item) ? { color: '#0795c4' } : {}}>
                          {item.href && !isCurrentPage(item) ? (
                            <a href={item.href}>{item.label}</a>
                          ) : (
                            item.label
                          )}
                        </span>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Breadcrumbs

